// extracted by mini-css-extract-plugin
export var headerAvatar = "styles-module--header-avatar--LTnAE";
export var avatarWrapper = "styles-module--avatar-wrapper--FK29+";
export var pbCorrection = "styles-module--pb-correction--35J17";
export var dropdown = "styles-module--dropdown--5Jyw2";
export var dropdownOverlay = "styles-module--dropdown-overlay--go4gQ";
export var option = "styles-module--option--1OxIP";
export var optionBlue = "styles-module--option-blue--ch3Jb";